import { createMessageRow } from './MessageRow.js';

/**
 * Компонент таблицы сообщений: добавляет новые сообщения, 
 * удаляет пустую строку, 
 * отслеживает ID
 */
export class MessagesTable {
    constructor(tbodyElement) {
        this.tbody = tbodyElement;  // ссылка на HTML элемент <tbody>
        this.messageIds = new Set(); // Отслеживаем уже отображенные ID
    }
    
    /**
     * Добавляет новые сообщения в таблицу
     * @param {Array} messages - Массив новых сообщений
     */
    addMessages(messages) {
        if (!messages || messages.length === 0) return;
        
        // Удаляем пустую строку, если она есть
        this.removeEmptyRow();
        
        // Добавляем каждое сообщение в начало таблицы (Если сообщение еще НЕ добавлено)
        for (const message of messages) {
            if (!this.messageIds.has(message.id)) {
                const row = createMessageRow(message);
                // Вставляем в начало tbody
                this.tbody.insertBefore(row, this.tbody.firstChild);
                // Запоминаем, что это сообщение уже добавили
                this.messageIds.add(message.id);
            }
        }
    }
    
    /**
     * Удаляет строку "Нет сообщений", чтобы добавить вместо нее реальные сообщения
     */
    removeEmptyRow() {
        const emptyRow = this.tbody.querySelector('.empty-row');
        if (emptyRow) {
            emptyRow.remove();
        }
    }
    
    /**
     * Показывает сообщение об отсутствии сообщений
     */
    showEmptyMessage() {
        // Если в таблице нет строк
        if (this.tbody.children.length === 0) {
            // Добавляем строку-заглушку
            this.tbody.innerHTML = `
                <tr class="empty-row">
                    <td colspan="3">Нет сообщений</td>
                </tr>
            `;
        }
    }
    
    /**
     * Очищает таблицу
     */
    clear() {
        this.tbody.innerHTML = '';
        this.messageIds.clear();
        this.showEmptyMessage();
    }
}

// // Было:
// <tbody>
//     <tr>Сообщение 1</tr>
//     <tr>Сообщение 2</tr>
// </tbody>

// // Вставляем новое сообщение в начало:
// this.tbody.insertBefore(newRow, this.tbody.firstChild);

// // Стало:
// <tbody>
//     <tr>НОВОЕ сообщение</tr>  // ← вставилось в начало
//     <tr>Сообщение 1</tr>
//     <tr>Сообщение 2</tr>
// </tbody>